import { render } from "./TriageStation.vue?vue&type=template&id=72081219&scoped=true"
import script from "./TriageStation.vue?vue&type=script&lang=js"
export * from "./TriageStation.vue?vue&type=script&lang=js"

import "./TriageStation.vue?vue&type=style&index=0&id=72081219&lang=css"
import "./TriageStation.vue?vue&type=style&index=1&id=72081219&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72081219"]])

export default __exports__